export const environment = {
  production: true,
  application_instance: '653b8ddc2e1023eadf0e00f7',

  data: {
    authServiceUrl: 'https://api-adaptivai.justplug.info/authentication/',
    api: 'https://api-adaptivai.justplug.info/',
    ui: {
      UseEmailInvitations: true
    }
  }
};
